import React, { useState, useEffect } from "react";
import "../Login/styles.css";
import axios from "axios";
import useAppData from "@/store/useAppData";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from "@/store/useRouter/types";
import logoAirlines from "../Login/logoAirlines.png"

const ChangePassword: React.FC = () => {

    const loggedUser = useAppData(state => state.user);

    const go = useRouter(state => state.go);

    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [checkPassword, setCheckPassword] = useState("");
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (!isPasswordValid(password) || !isPasswordValid(checkPassword) || password !== checkPassword) {
                return;
            }

            await updatePassword(loggedUser?.id!!, password);

            // setLoggedUser(user[0]);
            go({ key: RouterStoreItemKey.SELECTMODULE });
        } catch (e) {
            console.error(e);
        }
    };

    const isPasswordValid = (password) => {
        return (
            password.length >= 6 &&
            /[a-z]/.test(password) &&
            /[A-Z]/.test(password) &&
            /\d/.test(password)
        );
    }

    const updatePassword = async (user: string, pass: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/appuser/updatePassword",
                    data: {
                        id: user,
                        password: pass
                    }
                })
            );

            return res.data?.id;

        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    return (
        <div className="login-page">
            <div className="login-logo">
                <img src={logoAirlines} className="login-logo-img" />
                <span className="login-logo-text">Sklad</span>
            </div>

            <div className="login-card">
                <h1 className="login-title">
                    Změna hesla
                </h1>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="login-password-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            className="login-input login-input-password"
                            placeholder="Nové heslo"
                            required
                            value={password}
                            onChange={(e) => {
                                if (!isPasswordValid(e.target.value)) {
                                    setError("Heslo musí obsahovat alespoň 6 znaků, velké a malé písmeno a číslo");
                                } else if (e.target.value !== checkPassword) {
                                    setError("Hesla se neshodují");
                                } else {
                                    setError(null);
                                }

                                setPassword(e.target.value);
                            }}
                        />
                        <button
                            type="button"
                            className="login-password-toggle"
                            onClick={() => setShowPassword(v => !v)}
                        >
                            <svg className="login-password-icon" viewBox="0 0 24 24">
                                <path d="M12 4.5C6.5 4.5 2.3 8 1 12c1.3 4 5.5 7.5 11 7.5s9.7-3.5 11-7.5c-1.3-4-5.5-7.5-11-7.5zm0 12.5A5 5 0 1 1 12 7a5 5 0 0 1 0 10zm0-2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                            </svg>
                        </button>
                    </div>

                    <div className="login-password-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            className="login-input login-input-password"
                            placeholder="Potvrzení nového hesla"
                            required
                            value={checkPassword}
                            onChange={(e) => {
                                if (!isPasswordValid(password)) {
                                    setError("Heslo musí obsahovat alespoň 6 znaků, velké a malé písmeno a číslo");
                                } else if (password !== e.target.value) {
                                    setError("Hesla se neshodují");
                                } else {
                                    setError(null);
                                }

                                setCheckPassword(e.target.value);
                            }}
                        />
                        <button
                            type="button"
                            className="login-password-toggle"
                            onClick={() => setShowPassword(v => !v)}
                        >
                            <svg className="login-password-icon" viewBox="0 0 24 24">
                                <path d="M12 4.5C6.5 4.5 2.3 8 1 12c1.3 4 5.5 7.5 11 7.5s9.7-3.5 11-7.5c-1.3-4-5.5-7.5-11-7.5zm0 12.5A5 5 0 1 1 12 7a5 5 0 0 1 0 10zm0-2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                            </svg>
                        </button>
                    </div>
                    {error && (
                        <div style={{ color: "red", marginTop: 8 }}>
                            {error}
                        </div>
                    )}

                    <button type="submit" className="login-submit">
                        Změnit heslo
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;